var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.showBottomNav
    ? _c(
        "div",
        {
          staticClass: "bottom-bar-wrapper flex justify-center",
          class:
            !_vm.isCableAccessoriesPage &&
            !_vm.isOnCableSelection &&
            "sticky-overwrite",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "width-wrapper h-full w-full max-w-[1100px] flex justify-end items-center",
            },
            [
              _vm.isCableAccessoriesPage ||
              (_vm.bagStep == 3 &&
                _vm.activeCableSelectionMethods.length < 3 &&
                _vm.cablesNeededCount !== _vm.totalCablesSubmittedCount) ||
              (_vm.cablesNeededCount !== _vm.totalCablesSubmittedCount &&
                _vm.bagStep === _vm.totalSteps - 1 &&
                _vm.isOnCableSelection)
                ? _c(
                    "div",
                    {
                      staticClass:
                        "w-fit mr-2 text-center md:text-left text-sm md:text-xl font-bold text-blue-default md:py-1/2 md:px-2 cursor-pointer relative",
                      on: {
                        click: function ($event) {
                          _vm.showOptions = !_vm.showOptions
                        },
                      },
                    },
                    [
                      _vm._v("\n      Add Cable Selection Method\n      "),
                      _vm.showOptions
                        ? _c(
                            "div",
                            { staticClass: "options-modal" },
                            [
                              _vm._l(
                                _vm.cableSelectionAvailableOptions[
                                  _vm.activeProductKey
                                ],
                                function (method) {
                                  return [
                                    !_vm.activeCableSelectionMethods.includes(
                                      method
                                    )
                                      ? _c(
                                          "div",
                                          {
                                            key: method,
                                            staticClass:
                                              "method-wrapper w-full flex items-center",
                                            on: {
                                              click: function ($event) {
                                                return _vm.addCableSelectionMethod(
                                                  method
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c("Plus"),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                key: method,
                                                staticClass:
                                                  "mt-0 text-blue-dark ml-1/2",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    method === "mmy"
                                                      ? "Make/Model/Year"
                                                      : method.toUpperCase()
                                                  )
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                }
                              ),
                            ],
                            2
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isCableAccessoriesPage && _vm.totalCablesSubmittedCount === 0
                ? _c(
                    "div",
                    {
                      staticClass:
                        "w-fit border-1 border-blue-default rounded-full text-sm md:text-xl font-bold text-blue-default py-1/2 px-2 cursor-pointer hover:bg-blue-default hover:text-white inactive",
                    },
                    [_vm._v("\n      " + _vm._s(_vm.mainActionText) + "\n    ")]
                  )
                : _c(
                    "div",
                    {
                      staticClass:
                        "w-fit border-1 border-blue-default rounded-full text-sm md:text-xl font-bold text-blue-default py-1/2 px-2 cursor-pointer hover:bg-blue-default hover:text-white",
                      class: _vm.disabled && "inactive",
                      on: { click: _vm.mainActionMethod },
                    },
                    [_vm._v("\n      " + _vm._s(_vm.mainActionText) + "\n    ")]
                  ),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }